import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Moth silhouette uses the ★1 tier art. The active rendering for
// Ember Moth goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/ember_moth_3tier.jpg.
export const Moth = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/moth-1.png" size={size} alt="moth" />
)
